export const CLIENT_STORAGE_OWNER_KEY = "zuno.storage.owner.v1";

const AUTH_SCOPED_KEYS = Object.freeze([
  "usuarioLogado", "usuarioFoto", "userEmail", "telefone", "userType",
  "activeRideId", "corridasHistorico", "casa", "trabalho", "motoristasFavoritos",
  "driverUID", "deviceId", "locationDeviceId", "userLat", "userLng",
  "zuno.location.precise.v1", "zuno.ios.home.origin.v1", "zuno.ios.home.origin.logs.v1",
]);

const removeMatchingKeys = (storage, predicate) => {
  const keys = Array.from({ length: storage.length }, (_, index) => storage.key(index));
  keys.filter(key => key && predicate(key)).forEach(key => storage.removeItem(key));
};

export function clearAuthScopedClientState(storage = localStorage) {
  AUTH_SCOPED_KEYS.forEach(key => storage.removeItem(key));
  removeMatchingKeys(storage, key => key.startsWith("zunoPassengerSeen:"));
  storage.removeItem(CLIENT_STORAGE_OWNER_KEY);
}

export function bindClientStorageToUser(uid, storage = localStorage) {
  if (!uid) {
    clearAuthScopedClientState(storage);
    return { changed: false, cleared: true };
  }

  const previous = storage.getItem(CLIENT_STORAGE_OWNER_KEY);
  // A cache legada não informa a qual UID pertence. Na primeira execução da
  // correção ela deve ser descartada, assim como em qualquer troca de conta.
  const changed = previous !== uid;
  if (changed) clearAuthScopedClientState(storage);
  storage.setItem(CLIENT_STORAGE_OWNER_KEY, uid);
  return { changed, cleared: changed };
}

export function readAuthScopedClientValue(uid, key, storage = localStorage) {
  if (!uid || storage.getItem(CLIENT_STORAGE_OWNER_KEY) !== uid) return null;
  return storage.getItem(key);
}
